import EyebrowLabel from '@/components/SolutionsTemplate/EyebrowLabel';
import styles from "@/styles/solutionsTemplate/challenges.module.scss";
import GradientTitle from '@/components/SolutionsTemplate/GradientTitle';

interface Props {
    type: string,
    jsonData: any,
  }

export default function Challenges({
    type,
    jsonData,
}: Props) {

  return(
      <div className = {styles.rootDiv}>
          <EyebrowLabel type = {type} text = {jsonData.eyebrowLabel}/>
          <div style = {{width: "fit-content", margin: "0 auto", marginTop: "20px"}}>
              <GradientTitle 
                text = {jsonData.title}
                centeredText = {true}/>
          </div>
          <div 
            className = {styles.descriptionDiv}
            dangerouslySetInnerHTML = {{__html: jsonData.description}}/>
          <div style = {{margin: "0 auto", marginTop: "15px", width: "fit-content"}}>
              {jsonData.bottomText}
          </div>
      </div>
  );
}